import logger from "logging/logger";
import { useContext } from "react";
import { getFirstName, getLastName } from "helpers/nameHelper";
import { TRACKING_CONTEXT } from "modules/tracking";

const useNeedHelp = () => {
  // Getting from window everytime, because this object becomes undefined when going to another page

  const { identify } = useContext(TRACKING_CONTEXT);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getFcWidget = () => (window as any).fcWidget;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const callApi = (key: string, data?: any) => {
    const fcWidget = getFcWidget();

    if (!fcWidget) {
      return;
    }

    switch (key) {
      case "showNewMessage":
        fcWidget.open();
        break;

      case "update":
        try {
          if (data.email) {
            fcWidget.user.setEmail(data.email);
            identify(data.email, data);
          }

          if (data.name) {
            fcWidget.user.setFirstName(getFirstName(data.name));
            fcWidget.user.setLastName(getLastName(data.name));
          }
          fcWidget.user.setProperties(data);
        } catch (error) {
          const errorMessage = error instanceof Error ? error.message : "";
          logger.error(
            `useNeedHelp - error setting session data ${errorMessage}`,
            data,
          );
        }

        break;
      case "logout":
        // eslint-disable-next-line promise/catch-or-return, promise/prefer-await-to-then
        fcWidget.user.clear().then(
          // eslint-disable-next-line promise/always-return
          () => {
            logger.debug("Freshchat User context cleared");
          },
          () => {
            logger.debug("Freshchat User context not exist");
          },
        );
        break;
      default:
        break;
    }
  };

  return {
    callApi,
  };
};

export default useNeedHelp;
